import './App.css';
import Activities from './component/Activities/Activities';
import Blog from './component/Blogs/Blog';



function App() {
  return (
    <div className="App">
      <Activities></Activities>
      <Blog></Blog>
    </div>
  );
}

export default App;
